var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content-wrap page-top"},[_c('div',{staticClass:"container-fluid"},[_c('h2',[_vm._t("default")],2),_c('div',{staticClass:"page-top-right"},[_c('div',{staticClass:"system-title d-inline"},[_vm._v(" "+_vm._s(_vm.uiEnvVersion)+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }